module.exports = __webpack_public_path__ + "static/media/iphone_12_pro_blue.2a6c4308.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_12_pro_blue.png
// module id = 2096
// module chunks = 0